import { useSelector } from 'react-redux';

function useGraph() {
  return useSelector(({ graph }) => graph);
}

export default useGraph;
